"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureFlagEnabled = void 0;
var isFeatureFlagEnabled = function (flagName, skinConfig) {
    var _a, _b, _c;
    try {
        return (_c = (_b = (_a = skinConfig.skin_misc) === null || _a === void 0 ? void 0 : _a.feature_toggles) === null || _b === void 0 ? void 0 : _b[flagName]) !== null && _c !== void 0 ? _c : false;
    }
    catch (e) {
        return false;
    }
};
exports.isFeatureFlagEnabled = isFeatureFlagEnabled;
//# sourceMappingURL=FeatureFlags.js.map